import React, { useState, useEffect } from "react";
import MissionUserListAPI from "../../../api/api_calls/MissionUserListAPI";
import { useNavigate } from "react-router-dom";

const useUserMissionState = (missionId, refreshStatus) => {
    const navigate = useNavigate();
    const [userMissionState, setUserMissionState] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchUserMissionState = async () => {
            setIsLoading(true);
            const results = await MissionUserListAPI.show(missionId, navigate); // call your API

            if (results.success) {
                const mission_user_list = results.mission_user_list;
                if (mission_user_list) {
                    setUserMissionState(mission_user_list.status);
                } else {
                    setUserMissionState("not_applied");
                }
            } else {
                setUserMissionState(null);
            }
            setIsLoading(false);
        };

        fetchUserMissionState();
    }, [missionId, refreshStatus]);

    return { userMissionState, isLoading };
};

export default useUserMissionState;